import { BordersAdditive, BordersColor, BordersRadius, BordersSubtractive } from "../../../../src/examples/utilities/Borders";
import * as React from 'react';
export default {
  BordersAdditive,
  BordersColor,
  BordersRadius,
  BordersSubtractive,
  React
};